<template>
	<div>
		<v-form ref="formActual">
			<v-container>
				<v-row>
					<v-col cols="3">
						<span class="v-title">Signos y Síntomas</span>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3"> T/A </v-col>
					<v-col cols="4">
						<v-text-field
							suffix="mmHg"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.TA"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3"> Glucosa Capilar </v-col>
					<v-col cols="4">
						<v-text-field
							suffix="mg/dL"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.GlucosaCapilar"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3"> Temperatura </v-col>
					<v-col cols="4">
						<v-text-field
							type="number"
							suffix="ºC"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.Temperatura"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3"> Sat. O2 </v-col>
					<v-col cols="4">
						<v-text-field
							type="number"
							suffix="%"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.Saturacion"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row v-for="data in valor.SignosRangos" :key="data.nombre">
					<v-col cols="3">
						{{ data.Nombre }}
					</v-col>
					<v-col cols="4">
						<v-slider
							hide-details="auto"
							v-model="data.Valor"
							:thumb-size="30"
							thumb-label
							tick-size="4"
							:max="3"
							step="1"
						>
							<template v-slot:thumb-label="{ value }">
								{{ sliderVals[value] }}
							</template>
						</v-slider>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3"> Alteraciones dentales </v-col>
					<v-col cols="2">
						<v-radio-group
							hide-details="auto"
							class="campo-formulario"
							row
							mandatory
							v-model="valor.AlteracionesDentales"
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col cols="5">
						<v-text-field
							:rules="[
								!!valor.EspecifiqueAlteracionesDentales ||
									'Campo Obligatorio'
							]"
							class="campo-formulario"
							hide-details="auto"
							label="Especifique"
							v-model="valor.EspecifiqueAlteracionesDentales"
							v-if="valor.AlteracionesDentales"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3"> Alteraciones en piel </v-col>
					<v-col cols="2">
						<v-radio-group
							hide-details="auto"
							class="campo-formulario"
							row
							mandatory
							v-model="valor.AlteracionesPiel"
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col cols="5">
						<v-text-field
							:rules="[
								!!valor.EspecifiqueAlteracionesPiel ||
									'Campo Obligatorio'
							]"
							class="campo-formulario"
							hide-details="auto"
							label="Especifique"
							v-model="valor.EspecifiqueAlteracionesPiel"
							v-if="valor.AlteracionesPiel"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3"> Alteraciones en uñas </v-col>
					<v-col cols="2">
						<v-radio-group
							hide-details="auto"
							class="campo-formulario"
							row
							mandatory
							v-model="valor.AlteracionesUnas"
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col cols="5">
						<v-text-field
							:rules="[
								!!valor.EspecifiqueAlteracionesUnas ||
									'Campo Obligatorio'
							]"
							class="campo-formulario"
							hide-details="auto"
							label="Especifique"
							v-model="valor.EspecifiqueAlteracionesUnas"
							v-if="valor.AlteracionesUnas"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6">
						<span class="v-title">Capacidad Funcional</span>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="2"> Dinamometría (Kg) </v-col>
					<v-col cols="3">
						<v-text-field
							:rules="[
								!!valor.Dinamometria || 'Campo Obligatorio'
							]"
							suffix="kg"
							type="number"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.Dinamometria"
						></v-text-field>
					</v-col>
					<v-col cols="2"> Interpretación </v-col>
					<v-col cols="3">
						<v-text-field
							:rules="[
								!!valor.Interpretacion || 'Campo Obligatorio'
							]"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.Interpretacion"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="2"> Actividad Física </v-col>
					<v-col cols="3">
						<v-radio-group
							hide-details="auto"
							class="campo-formulario"
							row
							mandatory
							v-model="valor.ActividadFisica"
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<v-row v-if="valor.ActividadFisica">
					<v-col cols="1"> Tipo </v-col>
					<v-col cols="2">
						<v-text-field
							:rules="[
								!!valor.TipoActividad || 'Campo Obligatorio'
							]"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.TipoActividad"
						></v-text-field>
					</v-col>
					<v-col cols="2"> Frecuencia </v-col>
					<v-col cols="2">
						<v-text-field
							:rules="[
								!!valor.FrecuenciaActividad ||
									'Campo Obligatorio'
							]"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.FrecuenciaActividad"
						></v-text-field>
					</v-col>
					<v-col cols="2"> Duración </v-col>
					<v-col cols="2">
						<v-text-field
							:rules="[
								!!valor.DuracionActividad || 'Campo Obligatorio'
							]"
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.DuracionActividad"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6"> Observaciones </v-col>
				</v-row>
				<v-row>
					<v-col cols="1"><v-spacer></v-spacer></v-col>
					<v-col cols="8">
						<v-textarea
							outlined
							v-model="valor.Observaciones"
						></v-textarea>
					</v-col>
				</v-row>
			</v-container>
		</v-form>
		<v-layout row class="mt-3" v-if="!esVisita">
			<v-flex xs6>
				<v-btn color="primary" @click.prevent="anterior">
					<v-icon>arrow_back_ios</v-icon> ANTERIOR
				</v-btn>
			</v-flex>
			<v-flex xs6 class="text-right">
				<v-btn color="primary" @click.prevent="guardar">
					<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: ["datos", "esVisita", "validateForm"],
	name: "exploracionFisica",
	data() {
		return {
			valor: {
				signosSintomas: "",
				TA: "",
				GlucosaCapilar: "",
				Temperatura: "",
				Saturacion: "",
				SignosRangos: [
					{ Nombre: "Náuseas", Valor: "" },
					{ Nombre: "Vómitos", Valor: "" },
					{ Nombre: "RGE/Pirosis", Valor: "" },
					{ Nombre: "Distensión abdominal", Valor: "" },
					{ Nombre: "Diarrea", Valor: "" },
					{ Nombre: "Estreñimiento", Valor: "" },
					{ Nombre: "Anorexia/Hiporexia", Valor: "" },
					{ Nombre: "Hiperfagia", Valor: "" },
					{ Nombre: "Disfagia", Valor: "" },
					{ Nombre: "Disgeusia", Valor: "" },
					{ Nombre: "Astenia/Adinamia", Valor: "" },
					{ Nombre: "Prurito", Valor: "" },
					{ Nombre: "Disnea", Valor: "" },
					{ Nombre: "Edema", Valor: "" },
					{ Nombre: "Espasmo muscular", Valor: "" },
					{ Nombre: "Depleción de masa muscular", Valor: "" },
					{ Nombre: "Depleción de grasa subcutánea", Valor: "" }
				],
				AlteracionesDentales: false,
				AlteracionesPiel: false,
				AlteracionesUnas: false,
				Dinamometria: "",
				Interpretacion: "",
				ActividadFisica: false,
				TipoActividad: "",
				FrecuenciaActividad: "",
				DuracionActividad: ""
			},
			sliderVals: ["0", "+", "++", "+++"]
		};
	},
	mounted() {},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	methods: {
		siguiente() {
			this.$emit("siguiente");
		},
		anterior() {
			this.$emit("anterior");
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarExploracionFisica(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		}
	},
	watch: {
		datos() {
			if (this.datos) {
				this.valor =
					typeof this.datos === "string"
						? JSON.parse(this.datos)
						: this.datos;
			}
		},
		validateForm() {
			if (this.validateForm) {
				if (!this.$refs.formActual.validate()) {
					this.$emit("valorCambiado", null);
				} else {
					this.$emit("valorCambiado", this.valor);
				}
			}
		}
	}
};
</script>
<style>
.title {
	color: #1c62ad;
	font-size: 24px;
	font-weight: 400;
}
</style>
